import { CategoryMenu } from '@core/models/enum/category-menu.enum';

export const MENU = [
  {
    title: 'Sobre nós',
    url: '/sobre-nos.html',
    loggedIn: false,
    category: CategoryMenu.PRINCIPAL,
    order: 1,
  },
  {
    title: 'Resultados',
    url: '',
    loggedIn: false,
    category: CategoryMenu.PRINCIPAL,
    order: 4,
    submenus: [
      {
        title: 'Super Prêmio',
        url: '/resultados/super-premio.html',
        category: CategoryMenu.PRINCIPAL,
        loggedIn: false,
        order: 11,
      },
      {
        title: 'Prêmio Pix',
        url: '/resultados/premio-pix.html',
        category: CategoryMenu.PRINCIPAL,
        loggedIn: false,
        order: 10,
      },
    ],
  },
  {
    title: 'Sobre a',
    additionalTitle: 'Santa Casa SP',
    url: '/instituicao-beneficiada/sobre-santa-casa.html',
    loggedIn: false,
    category: CategoryMenu.PRINCIPAL,
    order: 2,
  },
  {
    title: 'Ajuda',
    url: '/ajuda/telepremios',
    loggedIn: false,
    category: CategoryMenu.PRINCIPAL,
    order: 3,
  },
  {
    title: 'Meus resultados',
    url: '/meus-resultados/conferir-resultados.html',
    loggedIn: true,
    category: CategoryMenu.USER_MENU,
    order: 5,
  },
  {
    title: 'Meus pedidos',
    url: '/meus-pedidos/lista.html',
    loggedIn: true,
    category: CategoryMenu.USER_MENU,
    order: 6,
  },
  {
    title: 'Meus títulos',
    url: '/meus-titulos/lista.html',
    loggedIn: true,
    category: CategoryMenu.USER_MENU,
    order: 7,
  },
  {
    title: 'Entrar',
    url: '/login.html',
    loggedIn: false,
    category: CategoryMenu.LOGIN_MENU,
    order: 8,
  },
  {
    title: 'Cadastrar',
    url: '/cadastro/dados-pessoais.html',
    loggedIn: false,
    category: CategoryMenu.LOGIN_MENU,
    order: 9,
  },
];
